import { distinct } from "@entrilia/shared/utilities/arrayHelper";
import type { Message } from "./types";

export const getFundsFromMessage = (message: Message): string[] => {
  const childTags = message.tags?.flatMap((tag) => tag.childTags);
  if (!childTags || childTags.length === 0) {
    return [];
  }

  return distinct(childTags.map((tag) => tag?.caption ?? "").filter(Boolean)).sort((a, b) => a.localeCompare(b));
};

export const getRecipientsFromMessage = (message: Message): string[] => {
  const tagCaptions = message.tags?.flatMap((tag) => tag.caption);
  return distinct((tagCaptions ?? []).filter(Boolean)).sort((a, b) => a.localeCompare(b));
};

export const getEntityFromMessage = (message: Message): string | undefined => {
  const secondLevelChildTags = message.tags?.flatMap((tag) => tag.childTags?.flatMap((tag) => tag.childTags));

  if (!secondLevelChildTags || secondLevelChildTags.length === 0) {
    return undefined;
  }

  return secondLevelChildTags[0]?.caption;
};
